import { disclosureService } from "@/services";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { qk } from "./queryKeys";

export function useDisclosure() {
	return useQuery({
		queryKey: qk.disclosure,
		queryFn: ({ signal }) => disclosureService.get(signal),
	});
}

export function useAcknowledgeDisclosure() {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: () => disclosureService.acknowledge(),
		onSuccess: () => qc.invalidateQueries({ queryKey: qk.disclosure }),
	});
}
